// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-25 22:35:21

export default {
  "id": "ragdoll-bounce",
  "slug": "ragdoll-bounce",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/6514adb546b24845b1bc0ba1cbeb42ee-512x512.jpg",
  "gameUrl": "https://html5.gamedistribution.com/6514adb546b24845b1bc0ba1cbeb42ee/",
  "releaseDate": "2025-03-25",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Ragdoll Bounce",
      "description": "Jump into a fun 2D challenge where you control a ragdoll launched by a bigger ragdoll. Click to bounce on platforms and keep climbing. But be careful—missing a platform means a big fall!",
      "instructions": "Control a ragdoll in a 2D jumping game, bouncing on platforms to stay in the air.",
      "genres": [
        "Agility",
        "Casual"
      ],
      "tags": [
        "jumping",
        "physics",
        "ragdoll",
        "skill",
        "stickman"
      ]
    },
    "zh-CN": {
      "title": "拉格doll弹跳",
      "description": "跳入一场有趣的2D挑战，控制一个由大号ragdoll发射的小ragdoll。点击跳跃在平台上，不断攀登。但要注意——错过平台会导致大坠落！",
      "instructions": "控制一个布娃娃在2D跳跃游戏中，弹跳在平台上保持空中。",
      "genres": [
        "敏捷性",
        "休闲"
      ],
      "tags": [
        "跳跃",
        "物理",
        "布娃娃效果",
        "技能",
        "棒人"
      ]
    },
    "zh-TW": {
      "title": "拉鍋彈跳",
      "description": "跳入一場有趣的2D挑戰，您將操控一個由較大的人體模型射出的布偶。點擊跳躍在平台上並持續攀登。但小心！錯過平台將會引發大顛簸！",
      "instructions": "控制一個布娃娃在2D跳躍遊戲中，利用平台彈跳以保持在空中。",
      "genres": [
        "敏捷度",
        "休闲"
      ],
      "tags": [
        "跳躍",
        "物理",
        "ragdoll",
        "技能",
        "stickman"
      ]
    },
    "zh-HK": {
      "title": "拉格鍛 bounce",
      "description": "跳入一個有趣的2D挑戰，你將操控一個由較大的ragdoll發射出的ragdoll。點擊跳躍在平台上並持續攀爬。但小心哦——錯過平台意味著一次大墜落！",
      "instructions": "控制一個布娃娃在2D跳躍遊戲中，在平台上彈跳以保持在空中。",
      "genres": [
        "敏捷度",
        "休闲"
      ],
      "tags": [
        "跳躍",
        "物理",
        "拉鍊人偶",
        "技能",
        "木人"
      ]
    },
    "ja": {
      "title": "ラグドールバウンス",
      "description": "ラグドールが打ち飛ばされた2Dの楽しい挑戦に飛び込んでください。プラットフォームにジャンプして登り続けますが、注意してください—プラットフォームをミスすると大きな落下になります！",
      "instructions": "2Dジャンプゲームでラグドールを操作し、プラットフォームに跳ねて空中を維持します。",
      "genres": [
        "アギリティ",
        "カジュアル"
      ],
      "tags": [
        "ジャンプ",
        "物理",
        "ラグドール",
        "スキル",
        "スティックマン"
      ]
    },
    "ko": {
      "title": "라그돌 브라운스",
      "description": "2D 챌린지에 점프해 큰 ragdoll에 의해 투입된 ragdoll을 제어해 보세요. 플랫폼에 클릭하여 뛰어 올라가 계속 씻어가세요. 하지만 주의하세요—플랫폼을 놓칠 경우 큰 추락이 됩니다!",
      "instructions": "2D 점프 게임에서 ragdoll을 제어하여 플랫폼 위에서 뛰어오르며 공중에 머무르세요.",
      "genres": [
        "순捷력",
        "캐주얼"
      ],
      "tags": [
        "점프",
        "물리학",
        "랩돌",
        "기술",
        "스틱맨"
      ]
    },
    "fr": {
      "title": "Ragdoll Rebond",
      "description": "Sauter dans un défi 2D amusant où vous contrôlez une poupée de paille lancée par une poupée de paille plus grande. Cliquez pour rebondir sur les plateformes et continuez à monter. Mais soyez prudent - manquer une plateforme signifie une grande chute !",
      "instructions": "Contrôlez une poupée de coton dans un jeu de saut en 2D, rebondissant sur des plateformes pour rester en l'air.",
      "genres": [
        "Agilité",
        "Loisir"
      ],
      "tags": [
        "saut",
        "physique",
        "ragdoll",
        "compétence",
        "stickman"
      ]
    }
  }
};
